import ProjectsParticipantsAdd from './ProjectsParticipantsAdd';

export default ProjectsParticipantsAdd;
